export default __webpack_public_path__ + "audio/274420784754a85ae6f332475fc4326a.mp3";